import React from 'react';
import {
    TextField,
} from '@shopify/polaris';

export function MetafieldNamespaceAndKeyFormElement(props) {

    const onValueChange = (value) => {
        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.metafieldNamespaceAndKey = value;
        props.onChange(newSettings);
    }

    return (
        <TextField
            label="Metafield Namespace and key"
            placeholder="Namespace and key. For example mystore.custom_size"
            helpText={
                <span>
                    The namespace and key as they appear in your admin.
                </span>
            }
            value={props.settings.metafieldNamespaceAndKey}
            error={props.settingsErrors["metafieldNamespaceAndKey"]}
            onChange={onValueChange}
            autoComplete="off"
        />
    );
}